import Input from 'tailwind-components/Input/Input';
import React from 'react';
import FormWithEditButton from 'tailwind-components/FormWithEditButton/FormWithEditButton';
import propTypes from 'prop-types';
import bankAccountFactory from 'helpers/factory/bankAccountFactory';
import useHiddenMode, { maskValue } from 'hooks/useHiddenMode';
import { useSelector } from 'react-redux';
import Card from 'tailwind-components/Card/Card';
import { getCompany } from 'helpers/getCompanyVariables';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';

const company = getCompany();
const isOneill = company === 'oneill';

export default function BankAccountForm({
  editButtonRef,
  setModalText,
  setIsOpenPrimaryModal,
  setIsOpenSecondaryModal,
  isAdmin = false
}) {
  const user = useSelector(state => state.user.zohoData);
  const { hidden } = useHiddenMode();

  const bankName = user.Name_of_Financial_Institution || '-';
  const accountNumber = user.Account_Number
    ? bankAccountFactory(user.Account_Number)
    : '-';
  // Only mask when there is real bank info, so the empty "- -" placeholder
  // still shows through in Hidden Mode.
  const hasBankInfo =
    !!user.Account_Number || !!user.Name_of_Financial_Institution;
  const bankAccountValue = maskValue(
    `${bankName} ${accountNumber}`,
    hidden && hasBankInfo
  );

  return (
    <Card
      title='Personal Bank Info'
      withSeparator
      separatorVariant='dashed'
      className='min-w-0 lg:col-span-1'
    >
      <div className='grow flex-1' ref={editButtonRef}>
        <FormWithEditButton
          buttonText='Edit'
          onClick={() => {
            setModalText('Personal Bank Information');
            isAdmin && isOneill
              ? setIsOpenSecondaryModal(true)
              : setIsOpenPrimaryModal(true);
          }}
        >
          <SimpleContainer>
            <Input
              label='Bank Account'
              value={bankAccountValue}
              placeholder='-'
              disabled
              compact
              wrapValue
              className='min-w-0'
              labelClassName='text-primary'
            />
            {isAdmin && (
              <p className='text-sm leading-none m-0 p-0 text-grey-light'>
                Note: If you are looking for your Agency Banking Information,
                you can go to Agency Management, select the Agency settings and
                you&apos;ll see your Agency Banking Information.
              </p>
            )}
          </SimpleContainer>
        </FormWithEditButton>
      </div>
    </Card>
  );
}

BankAccountForm.propTypes = {
  isAdmin: propTypes.bool,
  editButtonRef: propTypes.object,
  setModalText: propTypes.func,
  setIsOpenPrimaryModal: propTypes.func,
  setIsOpenSecondaryModal: propTypes.func
};
